import { getUserDepositsQuery } from './queries'
import { HttpClient } from '@injectivelabs/utils'
import { PEGGY_GRAPH_URL, THE_GRAPH_API_KEY } from '@/app/utils/constants'
import type { UserDeposit } from '@/types'

const padAddress = (address: string) => {
  return `0x${'0'.repeat(24)}${address.replace('0x', '')}`
}

export class PeggyTheGraphService {
  private client: HttpClient
  private endpoint: string
  private apiKey: string

  constructor({ endpoint, apiKey }: { apiKey: string; endpoint: string }) {
    this.apiKey = apiKey
    this.endpoint = endpoint
    this.client = new HttpClient(endpoint)

    this.client.setConfig({
      headers: { authorization: `Bearer ${this.apiKey}` }
    })
  }

  async getUserDeposits(destination: string, limit: number = 20) {
    const query = getUserDepositsQuery(padAddress(destination), limit)

    const response = await this.client.post<
      string,
      { data: { errors: string[]; data: { deposits: UserDeposit[] } } }
    >('', query)

    try {
      return response.data.data.deposits
    } catch {
      // console.log(response.data.errors)

      return []
    }
  }
}

let peggyTheGraphServiceInstance: null | PeggyTheGraphService = null

export const getPeggyTheGraphService = (): PeggyTheGraphService => {
  if (!peggyTheGraphServiceInstance) {
    peggyTheGraphServiceInstance = new PeggyTheGraphService({
      endpoint: PEGGY_GRAPH_URL(),
      apiKey: THE_GRAPH_API_KEY
    })
  }

  return peggyTheGraphServiceInstance
}
